import { FetchQRStatus } from '@entities/payment'

export const getQrFee = (
  qrStatusData: FetchQRStatus | undefined,

  isPubg: boolean,

  isTopUpWithPercentFeeService: boolean,
  isNonTopUpServiceDenomation: boolean
) => {
  if (isPubg || isTopUpWithPercentFeeService) {
    return 0
  }

  if (isNonTopUpServiceDenomation) {
    return (qrStatusData?.amount?.fee ?? 0) - 5000
  }

  return qrStatusData?.amount?.fee || ''
}
